import React from 'react'

import CustomIconsPack from './components/CustomIconsPack'

export default function CustomIcon(props: { type: Extract<keyof typeof CustomIconsPack, string> }) {
   return <>{(CustomIconsPack as any)[props.type] || null}</>
}
